<template>
  <li class="menu-label flex flex-col">
    <slot />
  </li>
</template>
<style lang="scss">
.menu-label {
  padding-top: 10px;
  padding-bottom: 10px;
  color: #847e7e;
  font-size: 14px;
  font-weight: 400;
}
</style>
